import { LitElement, html, animationHelpers, utils } from '@hh/global.js'
const { debounce } = utils

// Should match .product-drawer-slider__into-slide transition duration
const BUTTON_CHECK_DELAY = 1000

class SectionProductDrawerSlider extends LitElement {
  static properties = {}

  constructor() {
    super()
  }

connectedCallback() {
    super.connectedCallback()

    this.slides = this.querySelectorAll('.js-slide')
    this.buttonNext = this.querySelector('.js-next-button')
    this.buttonPrev = this.querySelector('.js-prev-button')
    this.activeIndex = 0

    this.buttonNext?.addEventListener('click', this.moveSlider.bind(this))
    this.buttonPrev?.addEventListener('click', this.moveSlider.bind(this))

    this.debounceButtonsCheck = debounce(this.buttonsCheck.bind(this), BUTTON_CHECK_DELAY)

    this.addEventListener('scroll', this.buttonsCheck.bind(this))
    window.addEventListener('resize', this.debounceButtonsCheck.bind(this))
  }

  firstUpdated() {
    super.firstUpdated()
    this.slideObservers()
    this.animationStages()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this.buttonNext?.removeEventListener('click', this.moveSlider.bind(this))
    this.buttonPrev?.removeEventListener('click', this.moveSlider.bind(this))
    this.removeEventListener('scroll', this.buttonsCheck.bind(this))
    window.removeEventListener('resize', this.debounceButtonsCheck.bind(this))
  }

  slideObservers() {
    this.slides.forEach(slide => {
      animationHelpers.createIntersectionObserver(
        slide,
        (inView) => slide.classList.toggle('in-view', inView),
        {
          onlyCallbackOnIntersection: false,
          disableAfterIntersection: false,
          threshold: 0.8,
          rootMargin: '100% 0px'
        }
      )
    })
  }

  moveSlider(event) {
    const directionString = event?.target?.dataset?.direction ?? null
    if (directionString === null) { return null }
    const direction = Number(directionString)

    const slidesToLoop = direction === 1
      ? [...this.slides].reverse()
      : [...this.slides]

    const firtsInViewSlideIndexString = slidesToLoop
      .find(slide => slide.classList.contains('in-view'))
      ?.dataset?.slideIndex ?? 0

    const moveToSlide = this.slides[Number(firtsInViewSlideIndexString) + direction]

    if (!moveToSlide) {
      return this.scrollTo({
        left: direction === 1
          ? this.scrollWidth - this.clientWidth
          : 0
      })
    }

    const moveToSlideRect = moveToSlide.getBoundingClientRect()
    const thisRect = this.getBoundingClientRect()
    const absoluteLeft = moveToSlideRect.left - thisRect.left + this.scrollLeft

    this.scrollTo({
      left: absoluteLeft - 24
    })
  }

  buttonsCheck() {
    const canScrollLeft = this.scrollLeft > 0
    const canScrollRight = (this.scrollLeft + this.clientWidth) < (this.scrollWidth - 2)

    this.buttonPrev?.toggleAttribute('disabled', !canScrollLeft)
    this.buttonNext?.toggleAttribute('disabled', !canScrollRight)
    this.classList.toggle('hide-scroll-buttons', !canScrollLeft && !canScrollRight)
  }

  animationStages() {
    animationHelpers.createIntersectionObserver(
      this,
      () => this.classList.remove('product-drawer-slider--stage-1'),
      {
        onlyCallbackOnIntersection: true,
        disableAfterIntersection: true,
        threshold: 0.4
      }
    )

    animationHelpers.createIntersectionObserver(
      this,
      () => {
        this.classList.remove('product-drawer-slider--stage-2')
        this.debounceButtonsCheck()
      },
      {
        onlyCallbackOnIntersection: true,
        disableAfterIntersection: true,
        threshold: 0.7
      }
    )
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('section-product-drawer-slider', SectionProductDrawerSlider)
